// extracted by mini-css-extract-plugin
export default {"btn_bx":"LoginStatus_btn_bx__530IB","welcome":"LoginStatus_welcome__nospN","btn":"LoginStatus_btn__TG7eq","username":"LoginStatus_username__uTiK2"};